import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {Button} from 'shells/button/button';
import {Link} from 'shells/link/link';
import {LoadingText} from 'shells/loading-placeholder/loading-text';

import {useGetAllMembershipStatsForAudience} from './graphql/hooks/use-get-all-membership-stats-for-audience';
import type {AudienceOption} from './map-audience-to-select-item';

type Props = {
    audience: AudienceOption;
    onSyncMcfxAudience: (mcfxAudience: AudienceOption) => void;
    isSmsEdition?: boolean;
};

export function FieldHelpText(props: Props) {
    const {emailMembershipStats, smsMembershipStats, isLoading} =
        useGetAllMembershipStatsForAudience(props.audience.value, Boolean(props.audience.isFx));

    const membershipStats = props.isSmsEdition ? smsMembershipStats : emailMembershipStats;

    const subscriberCount = props.audience.isFx
        ? props.audience.count
        : membershipStats?.subscribedCount;

    const audience: AudienceOption = props.audience;
    if (audience.isSyncing) {
        return <span>This audience is syncing… when it’s done you’ll be able to send to it.</span>;
    }

    if (audience.isFx && audience.requiresSync) {
        return (
            <div>
                This audience needs to be synced before you can send to it.{' '}
                <Button
                    variant='text-primary'
                    size='big'
                    onClick={() => {
                        props.onSyncMcfxAudience(audience);
                    }}
                >
                    Sync now?
                </Button>
            </div>
        );
    }

    if (isLoading) {
        return <LoadingText height={19} width={150} />;
    }

    if (subscriberCount) {
        return (
            <span>
                This {/* @ts-expect-error */}
                <Link as={RoutedLink} to={audience.htmlUrlPath} variant='primary' size='regular'>
                    audience
                </Link>{' '}
                has {subscriberCount.toLocaleString()}{' '}
                {subscriberCount === 1 ? 'subscriber' : 'subscribers'}
            </span>
        );
    }

    return null;
}
